import { useCustomerTicketsPage } from "modules/customerTickets/pages/CustomerTickets/context";
import React, { FC, useEffect, useRef } from "react";
import PrimaryButton from "shared/components/PrimaryButton";
import {
  StyledButtonContainer,
  StyledContainer,
  StyledTextField,
} from "./styled";

type Props = {
  setContainerHeight: (value: number) => void;
};

const MessageInput: FC<Props> = ({ setContainerHeight }) => {
  const { messageText, isSubmittingSupportMessage, onCreateSupportMessage } =
    useCustomerTicketsPage();

  const containerRef = useRef<HTMLDivElement>(null);
  const MARGIN = 24;

  useEffect(() => {
    if (containerRef.current) {
      setContainerHeight(containerRef.current.clientHeight + MARGIN);
    }
  }, [messageText?.input.value, setContainerHeight]);

  return (
    <StyledContainer ref={containerRef}>
      <StyledTextField
        multiline
        inputProps={{ maxRows: 10 }}
        variant="outlined"
        fullWidth
        value={messageText?.input.value}
        onChange={(e) => messageText?.setValue(e.target.value)}
        placeholder="Send a message"
      />
      <StyledButtonContainer>
        <PrimaryButton
          title="Send"
          size="small"
          loading={isSubmittingSupportMessage}
          disabled={isSubmittingSupportMessage || !messageText?.input.value}
          onClick={onCreateSupportMessage}
        />
      </StyledButtonContainer>
    </StyledContainer>
  );
};

export default MessageInput;
